export default {
  'tipSettings.title': '小费设置',
  'tipSettings.tabs.general': '基本',
  'tipSettings.tabs.dine-in': '堂食',
  'tipSettings.tabs.take-out': '外带',
  'tipSettings.tabs.delivery': '递送',
  'tipSettings.enableNoTips': '启用无小费选项',
  'tipSettings.enableSuggestedTipOptions': '启用建议小费选项',
  'tipSettings.customizeTipsOptions': '自定义建议小费选项',
  'tipSettings.suggestedTipsByPercentage': '建议小费(百分比)',
  'tipSettings.suggestedTipsByAmount': '建议小费(固定金额)',
  'tipSettings.tipOptions': '小费选项',
  'tipSettings.customizeTips.low': '低值',
  'tipSettings.customizeTips.medium': '中间值',
  'tipSettings.customizeTips.high': '高值',
  'tipSettings.percentage.required': '值必填',
  'tipSettings.defaultTip': '默认小费',
  'tipSettings.noTips': '无小费',
  'tipSettings.nullTips': '空值',
  'tipSettings.tipOptions.showBoth': '同时使用百分比和金额',
  'tipSettings.tipOptions.percentages_only': '使用百分比',
  'tipSettings.tipOptions.dollars_only': '使用固定金额',
  'tipSettings.tipOptions.percentages_first_if_exceeds': '超过一定金额后使用百分比',
  'tipSettings.tipOptions.percentages_first_if_exceeds.description':
    '低于这个金额，则显示小费选项为固定金额。高于这个金额，则显示小费选项为百分比',
  'tipSettings.tipCalculationsByDiscounts': '小费计算: 折扣',
  'tipSettings.tipCalculationsAfterTax': '使用账单总计 (税后)',
  'tipSettings.tipCalculationsBeforeTax': '使用小计 (税前)',
  'tipSettings.tipCalculationsAfterDiscount': '折后',
  'tipSettings.tipCalculationsBeforeDiscount': '折前(折扣将加回)',
  'tipSettings.discountDescription': '折扣包括订单和菜品折扣。税款不会重新计算。',
  'tipSettings.calculateTipsBefore': '建议小费计算基于下列项目之前',
  'tipSettings.calculateTipsBeforeTax': '税',
  'tipSettings.calculateTipsBeforeDiscount': '折扣',
  'tipSettings.paymentSignature': '自动采集付款签名',
  'tipSettings.allCardPay': '采集所有卡支付签名',
  'tipSettings.exceedPay': '超过固定金额后采集签名',
  'tipSettings.collectTipsViaReceipts': '通过收据手写收集小费',
  'tipSettings.tipCalculations': '小费计算',
  'tipSettings.tipCalculations.taxes': '税',
  'tipSettings.tipCalculations.discounts': '折扣',
  'tipSettings.tipCalculationsByTaxes': '小费计算: 税',
  'tipSettings.autoAppliedTipsFromFees': '附加费自动应用为小费',
  'tipSettings.displayAddTipssForAutoAppliedGratuity': '当已自动应用小费时显示“添加小费”',
  'tipSettings.displayAddTipssForAutoAppliedGratuity.description': '建议小费比例为税前3%，5%，7%，且不可配置。',
  'tipSettings.showMessageWhenTipAutoApplied':
    '自动应用小费时在账单上显示文本：“小费已包含在账单总额中。感谢您的光临！”',
  'tipSettings.maximumValueOfTips': '小费输入最大值',
  'tipSettings.maximumValueOfTips.description': '生效场景：客人输入小费、员工编辑小费',
  'tipSettings.remainderForTraditionalTipping': '手写小费添加的提醒（如有仍未添加小费的订单）',
  'tipSettings.remainderForTraditionalTipping.note': '注意: 小费尽量在营业当天完成添加，最晚次日中午12点前完成。',
  'tipSettings.tippingAlertTimePoint.5pmAtTheSameDay': '当日 5:00PM 提醒一次',
  'tipSettings.tippingAlertTimePoint.10amAtTheNextDay': '次日 10:00AM 提醒一次',
  'tipSettings.tippingAlertTimePoint.11amAtTheNextDay': '次日 11:00AM 提醒一次',
  'tipSettings.remainderForTraditionalTipping.voice': '小费添加的提醒增加声音提示',
  'tipSettings.displayGratuity': '费用提示',
  'tipSettings.showGratuityTips': '显示订单中算作小费的费用提示',
  'tipSettings.boldGratuityTips': '突出显示费用提示信息',
};
